import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';
import type { Observable } from 'rxjs';

import { filterBoolean } from '@core/common-legacy';
import { JobBoard } from '@recruitee/job-boards-types';

import {
  JobTemplatesJobBoardActions,
  JobTemplatesJobBoardSelectors,
} from './job-templates-job-board.store';

@Injectable({ providedIn: 'root' })
export class JobTemplatesJobBoardStoreService {
  private readonly store = inject(Store);

  public getJobTemplatesJobBoards(jobTemplateId: number): Observable<JobBoard[]> {
    return this.store
      .select(JobTemplatesJobBoardSelectors.entities({ scope: jobTemplateId.toString() }))
      .pipe(filterBoolean);
  }

  public getJobTemplatesJobBoardsLoaded(jobTemplateId: number): Observable<boolean> {
    return this.store.select(
      JobTemplatesJobBoardSelectors.isLoaded({ scope: jobTemplateId.toString() }),
    );
  }

  public fetchJobTemplatesJobBoards(jobTemplateId: number): void {
    this.store.dispatch(
      JobTemplatesJobBoardActions.fetchCollection({ payload: { scope: jobTemplateId.toString() } }),
    );
  }
}
